module.exports = __webpack_public_path__ + "img/negx.9801efa7.jpg";